import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa o Bootstrap CSS
import './App.css'; // Seu CSS customizado
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CheckinPage from './Pages/Checkin/CheckinPage';
import AreaRestritaPage from './Pages/AreaRestrita/AreaRestritaPage';
import BarGerentePage from './Pages/BarGerente/BarGerentePage';
import BarBarmanPage from './Pages/BarBarman/BarBarmanPage';
import BarCozinhaPage from './Pages/BarCozinha/BarCozinhaPage';
import BarGarconPage from './Pages/BarGarcon/BarGarconPage';
import PagamentoContaMaquininha from './Pages/PagamentoContaMaquininha/PagamentoContaMaquininha';
import UsuarioLogadoPage from './Pages/UsuarioLogado/UsuarioLogadoPage';
import SobrePage from './Pages/Sobre/SobrePage';
import BuscarPage from './Pages/Buscar/BuscarPage';
import MostrarDadosEstabelecimento from './Pages/MostrarDadosEstabelecimento/MostrarDadosEstabelecimento';
import DadosDoEstabelecimento from './Pages/DadosDoEstabelecimento/DadosDoEstabelecimentoPage'
import UsuarioCheckadoPage from './Pages/UsuarioCheckado/UsuarioCheckadoPage';
import ProdutosPage from './Pages/Produtos/ProdutosPage';
import CheckinsAbertos from './Pages/CheckinsAbertos/CheckinsAbertos';
import MeusProdutosPage from './Pages/MeusProdutos/MeusProdutosPage';
import PagamentoFinalizado from './Pages/PagamentoFinalizado/PagamentoFinalizado';
import CardapioPage from './Pages/Cardapio/CardapioPage';
import PedidosPage from './Pages/Pedidos/PedidosPage';
import MeusPedidosEmAndamento from './Pages/MeusPedidosEmAndamento/MeusPedidosEmAndamento';
import MinhasFichas from './Pages/MinhasFichas/MinhasFichas';
import MinhasFichasPagas from './Pages/MinhasFichasPagas/MinhasFichasPagas';
import MeusPedidosEntregues from './Pages/MeusPedidosEntregues/MeusPedidosEntregues';
import MinhasFichasUtilizadas from './Pages/MinhasFichasUtilizadas/MinhasFichasUtilizadas';
import PedidosEntreguesNaMesa from './Pages/PedidosEntreguesNaMesa/PedidosEntreguesNaMesa';
import AtualizarCheckinQrCodeMesa from './Pages/AtualizarCheckinQrCodeMesa/AtualizarCheckinQrCodeMesa';
import FazerCheckinPorQrCode from './Pages/FazerCheckinPorQrCode/FazerCheckinPorQrCode';
import GerarQrCodeMesa from './Pages/GerarQrCodeMesa/GerarQrCodeMesa';
// Dashboard
import DashboardMesasAbertas from './Pages/DashboardMesasAbertas/DashboardMesasAbertas';

// cadastros
import FormCadastrarGerente from './Pages/FormCadastrarGerente/FormCadastrarGerente';
import FormCadastrarCliente from './Pages/FormCadastrarCliente/FormCadastrarCliente';
import FormCadastrarFuncionario from './Pages/FormCadastrarFuncionario/FormCadastrarFuncionario'
import FormCadastrarOutrosProdutos from './Pages/FormCadastrarOutrosProdutos/FormCadastrarOutrosProdutos'

// tab
import TabComponent from './components/Tab/TabComponent'; // Mantemos o TabComponent aqui, mas vamos usar só para renderizar as abas

const App = () => {
  return (
    <div className="container mt-4">
      {/* <h1 className="text-center mb-4">Bem-vindo ao Bar Inteligente!</h1> */}
      
      {/* Permitir navegar pelas páginas */}
      <Router>

        <Routes>

          <Route path="/" element={<CheckinPage />} />
          <Route path="/mostrar-dados-estabelecimento" element={<MostrarDadosEstabelecimento />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/buscar" element={<BuscarPage />} />
          <Route path="/area-restrita" element={<AreaRestritaPage />} />
          <Route path="/usuario-logado" element={<UsuarioLogadoPage />} />
          <Route path="/bar-gerente" element={<BarGerentePage />} />
          <Route path="/bar-barman" element={<BarBarmanPage />} />
          <Route path="/bar-cozinha" element={<BarCozinhaPage />} />
          <Route path="/bar-garcon" element={<BarGarconPage />} />
          <Route path="/pagamento-conta-maquininha" element={<PagamentoContaMaquininha />} />
          <Route path="/dados-do-estabelecimento" element={<DadosDoEstabelecimento />} />
          <Route path="/form-cadastrar-gerente" element={<FormCadastrarGerente />} />
          <Route path="/form-cadastrar-cliente" element={<FormCadastrarCliente />} />
          <Route path="/form-cadastrar-funcionario" element={<FormCadastrarFuncionario />} />
          <Route path="/form-cadastrar-outros-produtos" element={<FormCadastrarOutrosProdutos />} />
          <Route path="/checkins-com-contas-em-aberto" element={<CheckinsAbertos />} />
          <Route path="/usuario-checkado" element={<UsuarioCheckadoPage />} />
          <Route path="/produtos" element={<ProdutosPage />} />
          <Route path="/meus-produtos" element={<MeusProdutosPage />} />
          <Route path="/pagamento-finalizado" element={<PagamentoFinalizado />} />
          <Route path="/cardapio" element={<CardapioPage />} />
          <Route path="/pedidos" element={<PedidosPage />} />
          <Route path="/meus-pedidos-em-andamento" element={<MeusPedidosEmAndamento />} />
          <Route path="/minhas-fichas" element={<MinhasFichas />} />
          <Route path="/minhas-fichas-pagas" element={<MinhasFichasPagas />} />
          <Route path="/meus-pedidos-entregues" element={<MeusPedidosEntregues />} />
          <Route path="/minhas-fichas-utilizadas" element={<MinhasFichasUtilizadas />} />
          <Route path="/pedidos-entregues-na-mesa" element={<PedidosEntreguesNaMesa />} />
          <Route path="/atualizar-checkin-qrcodemesa/:numeroMesa/:idEstabelecimento" element={<AtualizarCheckinQrCodeMesa />} />
          <Route path="/fazer-checkin-por-qrcode/:numeroMesa/:idEstabelecimento" element={<FazerCheckinPorQrCode />} />
          <Route path="/gerar-qr-code-mesa" element={<GerarQrCodeMesa />} />
          <Route path="/visualizar-dashboard-mesas-abertas" element={<DashboardMesasAbertas />} />
          
        </Routes>

        {/* Tabs - fora das rotas */}
        <TabComponent />
        
      </Router>
    </div>
  );
};

export default App;
